import BugsnagPerformance from '@bugsnag/browser-performance';

const apiKey = process.env.NEXT_PUBLIC_BUGSNAG_API_KEY;

if (typeof window !== 'undefined') {
    BugsnagPerformance.start({
        apiKey,
    });
}
